@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <div style="display:flex; align-items:flex-end; flex-wrap:wrap; column-gap:20px; row-gap:12px; margin-bottom:20px;">
      <h3 style="margin:0; align-self:center; white-space:nowrap;" i18n>Admission Report for period: </h3>
      <div>
        <label style="display:block; margin-bottom:4px;">From Date:</label>
        <p-datepicker [selectOtherMonths]="true" [(ngModel)]="FromDate" (onSelect)="fromDateChanged()" (onInput)="fromDateChanged()" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" [inputStyle]="{'width':'130px'}"></p-datepicker>
      </div>
      <div>
        <label style="display:block; margin-bottom:4px;">To Date:</label>
        <p-datepicker [selectOtherMonths]="true" [(ngModel)]="ToDate" [minDate]="FromDate" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" [inputStyle]="{'width':'130px'}"></p-datepicker>
      </div>
      <div>
        <label style="display:block; margin-bottom:4px;">Tags:</label>
        <p-multiselect [options]="tags" optionLabel="name" [(ngModel)]="chosentags" display="chip" placeholder="Select Tag(s)" [style]="{'width':'200px'}">
          <ng-template let-value #selecteditems>
            @for (tag of chosentags; track tag) {
              <span>
                <p-chip class="mr-2" label="{{tag.name}}" [style]="{'background': tag.colour, 'color': 'white', 'border-radius': '5px' }">
                </p-chip>
              </span>
            }
            @if (!chosentags || chosentags.length === 0) {
              <div class="country-placeholder"> Select Tag(s) </div>
            }
          </ng-template>
        </p-multiselect>
      </div>
      <div style="display:flex; gap:8px;">
        <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto" style="background-color: #22C55E;border-color: #22C55E;" (click)="doneDate()">
          Go
        </button>
        @if (ListBookings) {
          <button
            type="button"
            pButton
            pRipple
            (click)="AdmissionTable.exportCSV()"
            pTooltip="Export to CSV"
            tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-file-excel" aria-hidden="true"></span></button>
          }
        </div>
      </div>
      <div class="surface-card p-4 shadow-2 border-round">
        <p-table #AdmissionTable
          [columns]="cols"
          [value]="ListBookings"
          responsiveLayout="scroll">
          <ng-template #header>
            <tr>
              <th width="9%">Sales ID</th>
              <th width="10%">Start Date/Time</th>
              <th width="10%">Name</th>
              <th width="14%">Package</th>
              <!-- One column per admission type the period actually contains. -->
              @for (column of admissionColumns; track column) {
                <th style="text-align: center;">{{column.name}}</th>
              }
              <th style="text-align: center;" width="5%">Guests</th>
              <th style="text-align: right;" width="6%">Total</th>
              <th style="text-align: right;" width="6%">O/S</th>
            </tr>
          </ng-template>
          <ng-template #body let-rowData>
            <tr onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'"
              onmouseout="this.style.backgroundColor=this.originalstyle;"
              [ngStyle]="{'background-color': rowData.disabled ? '#fee' : ((rowData.allergy != null && rowData.allergy != '') ? '#FFFFB2' : '#ffffff')}"
              style="cursor:pointer;"
              (click)="editdata(rowData.bookingId)">
              <td>{{rowData.bookingIdHR}}</td>
              <td>{{rowData.startTime | date:'dd/MM/yy HH:mm' : 'UTC'}}</td>
              <td>{{rowData.name}}</td>
              <td>{{rowData.packageName}}</td>
              @for (column of admissionColumns; track column) {
                <td style="text-align: center;">{{rowData[column.key] || ''}}</td>
              }
              <td style="text-align: center;">{{rowData.guests}}</td>
              <td style="text-align: right;">{{rowData.total | currency: (rowData.currency || CurrencySymbol)}}</td>
              <td style="text-align: right;" [ngStyle]="{'color': rowData.outstanding > 0 ? 'red' : '', 'font-weight': rowData.outstanding > 0 ? 'bold' : ''}">{{rowData.outstanding | currency: (rowData.currency || CurrencySymbol)}}</td>
            </tr>
          </ng-template>
          <ng-template #footer>
            @if (ListBookings != null && ListBookings.length > 0) {
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td style="text-align: right;"><b>Total</b></td>
                <!-- How many of each admission went out over the whole period. -->
                @for (column of admissionColumns; track column) {
                  <td style="text-align: center;"><b>{{column.total}}</b></td>
                }
                <td style="text-align: center;"><b>{{guests}}</b></td>
                <td style="text-align: right;"><b>{{total | currency: CurrencySymbol}}</b></td>
                <td style="text-align: right;"><b>{{outstanding | currency: CurrencySymbol}}</b></td>
              </tr>
            }
            @if (ListBookings == null || ListBookings.length == 0) {
              <tr>
                <td style="text-align: center;" colspan="20">
                  There is no data for the selected date range.
                </td>
              </tr>
            }
          </ng-template>
        </p-table>
      </div>
    </div>
  }
